import React from 'react'
import { useHistory } from 'react-router-dom'
import styles from './Home.module.css'
 

const Home = () => {
   const history = useHistory() 
   const user = JSON.parse(localStorage.getItem('profile'))
   if(!user) {
        history.push('/login')
      }
    return (
        <div className={styles.pageContainer}>
            
            <section className={styles.hero}>
                
               
                <div className={styles.imgContainer}>
                    <img src="yasinimain.png" alt="invoicing-app"/>
                </div>
            </section> 
        </div>
    )
}

export default Home
